import React from 'react'
import { Heading } from '@myxplor/ui'
import { fileNameWithDate } from '../../io/download-csv'
import { startOfWeek, dayFormat } from '../../week'
import { CCSWeekInput } from './ccs-week-input'
import { validateCCSStartDate } from './helpers'
import ReportForm from '../views/form'

const onSubmit = ({ gov_id, record_type }) => ({ remote_request }) => payload =>
  remote_request.submit({
    url: `${apiEndPoint({ gov_id, record_type })}?week_start_date=${payload.week_start_date}`,
    method: 'GET',
    fileName: fileNameWithDate('CCS Submissions Report'),
  })

const FormFields = ({ values, errors, onChange, valid }) => (
  <fieldset>
    <Heading small>CCS Weekly Submissions Report</Heading>
    <CCSWeekInput
      reportName="CCS Submissions"
      value={values.week_start_date}
      errors={errors.week_start_date}
      onChange={onChange}
      valid={valid}
    />
  </fieldset>
)

const apiEndPoint = ({ gov_id, record_type }) =>
  process.env.REACT_APP_API_HOST + `/api/${record_type}/${gov_id}/reports/session-reports`

export const ReportCCSSessions = ({ gov_id, record_type, resetCurrentReport }) => (
  <ReportForm
    formOptions={{
      validate: validateCCSStartDate,
      defaultValues: {
        week_start_date: dayFormat(startOfWeek()),
      },
    }}
    name="CCS Submissions Report"
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
    onSubmit={onSubmit({ gov_id, record_type })}
  />
)



// WEBPACK FOOTER //
// ./src/reports/reports/ccs-sessions.jsx